import type {
  OrganizationContextListFilterObject,
  UseOrganizationContextListFilterProps,
} from "./organization-context-list-filter.type";

import { useMemo } from "react";

import { useOrganizationContext } from "@/modules/organization/organization-context";

export const useOrganizationContextListFilter = ({
  withContext,
}: UseOrganizationContextListFilterProps) => {
  const { contextSlug } = useOrganizationContext();

  const contextFilter = useMemo((): OrganizationContextListFilterObject => {
    if (!withContext) return {};

    // Enforce `null` fallback to let api pick default context if `context.slug` is not defined
    return { [`context[organization]`]: contextSlug ?? null };
  }, [withContext, contextSlug]);

  return {
    contextFilter,
  };
};
